import React, { useState, useEffect, useRef } from "react";
import MultiSlider from "../multislider/multislider";
import "../multislider/multislider.css";
import "../mainslider/slider.css";
import Threedslider from "../3dslider/3dslider";
import "../3dslider/3dslider.css";
import PortaritSlider from "../portraitSlider/portraitSlider";
import "../portraitSlider/portraitSlider.css";
import TabbedSlider from "../tabbedslider/tabbedslider";
import "../tabbedslider/tabbedslider.css";
import ImageBanner from "../imageBanner/imageBanner";
import ArticleSlider from "../articleSlider/articleSlider";
import NewsCarousel from "../newsCarousel/newsCarousel";
import List from "../list/list";
import LandscapeSlider from "../landscapeSlider/landscapeSlider";
import ThreePortaritSlider from "../threeportraitSlider/threeportraitSlider";
import PortraitList from "../portraitList/portraitList";
import LandscapeList from "../landscapeList/landscapeList";
import TextGrid from "../gridcontainer/textGrid";
import HighlightTextGrid from "../gridcontainer/highlightTextGrid";
import Grid from "../gridcontainer/grid";
import DoubleGrid from "../gridcontainer/doubleGrid";
import HeroCarousel from "../mainslider/slider";
import Embed from "../embed/embed";
import ErrorBoundary from "../error/error";
import VideoPlayer from "../videoPlayer/VideoPlayer";

//import ErrorBoundary from "../error/error"

const Element = (props) => {
  const [elemid, SetElemId] = useState("");

  const [elemname, setElemName] = useState("");
  const [elemInfo, setElemInfo] = useState([]);
  const [elemType, setElemType] = useState("");
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    if (mounted.current) {
      setElemType(props.type);
      SetElemId(props.id);
      setElemName(props.name);
      setElemInfo(props.information);
    }

    return () => {
      mounted.current = false;
    };
  }, [props.id, props.name, props.information, props.type]);

  if (elemType === "3dCarousel") {
    return (
      <ErrorBoundary>
        <Threedslider
          id={elemid}
          information={elemInfo}
          {...props}
        ></Threedslider>
      </ErrorBoundary>
    );
  } else if (elemType === "landscapeSlider") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <LandscapeSlider
            id={elemid}
            name={elemname}
            information={elemInfo}
            {...props}
            header={true}
          ></LandscapeSlider>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "multiCarousel") {
    return (
      <div>
        <ErrorBoundary>
          <MultiSlider
            id={elemid}
            information={elemInfo}
            {...props}
          ></MultiSlider>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "newsCarousel") {
    return (
      <div>
        {(props.match.params.AppId === "67bedfa6984a830020a13304") && (
          <ErrorBoundary>
            <VideoPlayer {...props} />
          </ErrorBoundary>
        )}
        <ErrorBoundary>
          <NewsCarousel
            id={elemid}
            information={elemInfo}
            multiple={true}
            {...props}
          ></NewsCarousel>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "movieCarousel") {
    return (
      <div>
        {(props.match.params.AppId === "6791c1e0ef1fe5183be52ce8" ||
          props.match.params.AppId === "67b6ac45984a830020a10f2f" ||
          props.match.params.AppId === "67b80532984a830020a11eae" ) && (
          <ErrorBoundary>
            <VideoPlayer {...props} />
          </ErrorBoundary>
        )}

        <ErrorBoundary>
          <HeroCarousel
            id={elemid}
            information={elemInfo}
            {...props}
          ></HeroCarousel>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "adBanner") {
    return (
      <div style={{ paddingTop: "10px", marginBottom: "10px" }}>
        <ErrorBoundary>
          <ImageBanner
            id={elemid}
            information={elemInfo}
            {...props}
          ></ImageBanner>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "portraitSlider") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <PortaritSlider
            id={elemid}
            information={elemInfo}
            name={elemname}
            header={true}
            {...props}
          ></PortaritSlider>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "bigportraitSlider") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <ThreePortaritSlider
            id={elemid}
            information={elemInfo}
            name={elemname}
            header={true}
            {...props}
          ></ThreePortaritSlider>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "portraitList") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <PortraitList
            id={elemid}
            information={elemInfo}
            name={elemname}
            header={true}
            {...props}
          ></PortraitList>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "landscapeList") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <LandscapeList
            id={elemid}
            information={elemInfo}
            name={elemname}
            header={true}
            {...props}
          ></LandscapeList>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "articleSlider") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <ArticleSlider
            id={elemid}
            information={elemInfo}
            name={elemname}
            tag={true}
            header={true}
            {...props}
          ></ArticleSlider>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "newsSlider") {
    return (
      <div style={{ paddingTop: "10px" }}>
        <ErrorBoundary>
          <ArticleSlider
            id={elemid}
            information={elemInfo}
            name={elemname}
            tag={false}
            header={true}
            {...props}
          ></ArticleSlider>{" "}
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "newsList") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <List
            id={elemid}
            information={elemInfo}
            header={true}
            {...props}
          ></List>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "articleList") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <List
            id={elemid}
            information={elemInfo}
            header={true}
            {...props}
          ></List>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "grid") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <Grid
            id={elemid}
            information={elemInfo}
            name={elemname}
            tag={false}
            header={true}
            {...props}
          ></Grid>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "doubleGrid") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <DoubleGrid
            id={elemid}
            information={elemInfo}
            name={elemname}
            tag={false}
            header={true}
            {...props}
          ></DoubleGrid>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "tabItem") {
    return (
      <div
        style={{ paddingTop: "10px", overflowX: "hidden", overflowY: "hidden" }}
      >
        <ErrorBoundary>
          <TabbedSlider
            id={elemid}
            elem={elemid}
            active={"pills-additions"}
            {...props}
          ></TabbedSlider>{" "}
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "textGrid") {
    return (
      <div
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <ErrorBoundary>
          <TextGrid
            id={elemid}
            information={elemInfo}
            header={true}
            {...props}
          ></TextGrid>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "highlightTextGrid") {
    return (
      <div
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <ErrorBoundary>
          <HighlightTextGrid
            id={elemid}
            information={elemInfo}
            header={true}
            {...props}
          ></HighlightTextGrid>
        </ErrorBoundary>
      </div>
    );
  } else if (elemType === "embed") {
    return (
      <div
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <ErrorBoundary>
          <Embed
            id={elemid}
            information={elemInfo}
            header={true}
            {...props}
          ></Embed>
        </ErrorBoundary>
      </div>
    );
  } else {
    return <div style={{ minHeight: "400px" }}></div>;
  }
};

export default Element;
